import { TermsLine } from './terms-line';

export default TermsLine;
